//ALL REACT
import * as React from 'react';
//MUI COMPONENTS
import { Typography, TextField, Button } from '@mui/material';
//MUI ICONS
import { EditDocument } from '@mui/icons-material';
//STYLES
import styles from '../../../module_css/formsCatalogs.module.css';
//PICTURES
import imgUpdate from '../../../assets/svg/update.svg';
//API CONTROLLER
import ApiController from '../../../controllers/api';
//CUSTOM COMPONENTS
import CustomBackdrop from '../../CustomBackdrop';
//OTHERS
import Swal from 'sweetalert2';

const ERROR_MESSAGES = {
  required:  "EL CAMPO ES OBLIGATORIO",
  invalid:   "EL VALOR DEL CAMPO NO CUMPLE CON EL FORMATO",
  minLength: "EL VALOR DEL CAMPO ES DEMASIADO CORTO",
  maxLength: "EL VALOR DEL CAMPO ES DEMASIADO LARGO"
};
const PROPERTIES_ENTRIES = {
    nombre: {
      required: true,
      pattern: /^[A-ZÁÉÍÓÚÜÑ0-9\s.'"-]+$/,
      minLength: 10,
      maxLength: 100
    },
    ubicacion: {
      required: true,
      pattern: /^[A-ZÁÉÍÓÚÜÑ0-9\s.,'"()\-:;\/#°]+$/,
      minLength: 10,
      maxLength: 100
    }
}
export default function FormEditBuilding ({ id = null, handleClose, refreshArea }){
  const [openBackdrop, setOpenBackdrop] = React.useState(false);
  const [data, setData] = React.useState({
    nombre: "",
    codigo: "",
    ubicacion: ""
  });
  const [errors, setErrors] = React.useState({
    nombre: [],
    ubicacion: [],
  });
  const apiInstance = React.useMemo(() => new ApiController(process.env.REACT_APP_API_URL), []);

  const getData = async (id) => await apiInstance.get(`/building/${id}`);
  const updateData = async (data) => await apiInstance.put(`/building/${id}`,data);

  const handleChange = (e) => {//CONTROLA LAS ENTRADAS DE LOS INPUTS
    const { name, value } = e.target;
    setData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  React.useEffect(() => {
    (async () => {
      setOpenBackdrop(true);
      const res = await getData(id);
      if (res.success) {
        setData({
          nombre: res.data?.NOMBRE,
          codigo: res.data?.CODIGO,
          ubicacion: res.data?.UBICACION
        });
      } else if(!res.success){
        Swal.fire({
            title: '¡ERROR! ❌',
            icon: 'error',
            text: 'NO SE PUDIERON CARGAR LOS DATOS',
            showConfirmButton: true,
            allowOutsideClick: false,
            allowEscapeKey: false,
            confirmButtonColor:'#ef7474',
            confirmButtonText: 'CONFIRMAR',
            padding: '0 0 20px'
          });
      handleClose();
      }
      setOpenBackdrop(false);
    })();
  }, [id]);

  const validateFieldGeneric = (value, options = {}) => {
  const errors = [];
    if (options.required && !value) errors.push({ type: "required" });
    if (value && options.pattern && !options.pattern.test(value)) errors.push({ type: "invalid" });
    if (value && options.minLength && value.length < options.minLength) errors.push({ type: "minLength" });
    if (value && options.maxLength && value.length > options.maxLength) errors.push({ type: "maxLength" });
    return errors;
  };

  const validateAllFields = () => {
    const newErrors = {};
    for (const field in PROPERTIES_ENTRIES) {
      newErrors[field] = validateFieldGeneric(data[field], PROPERTIES_ENTRIES[field]);
    }
    setErrors(newErrors);
    return !Object.values(newErrors).some(fieldErrors => fieldErrors.length > 0);
  };

  const getHelperText = (field) => {
    return errors[field].map(e => "- *" + ERROR_MESSAGES[e.type]).join("\n") || "";
  };

 const handleSubmit = (event) => {
  event.preventDefault();
  if (!validateAllFields()) return; // Detiene el envío si hay errores
    Swal.fire({
      title: "ACTUALIZAR ÁREA ⚠️",
      text: "¿ESTAS SEGURO QUE DESEAS ACTUALIZAR ESTE EDIFICIO?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "SI, ACTUALIZAR",
      confirmButtonColor: "#1a76d2",
      allowOutsideClick: false,
      allowEscapeKey: false
    }).then(async (result) => {
      if (result.isConfirmed) {
        setOpenBackdrop(true);
            const sentData = {
                NOMBRE: data.nombre.toUpperCase(),
                UBICACION: data.ubicacion.toUpperCase()
          }
          const res = await updateData(sentData);
          if (res.success) {
            Swal.mixin({
              toast: true,
              position: "bottom-start",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true
            }).fire({
              icon: "success",
              title: "EDIFICIO ACTUALIZADO",
              text: "SE ACTUALIZO CORRECTAMENTE"
            });
            handleClose();
            if (refreshArea) refreshArea();
          }else if(!res.success && res.meta.conflictDuplicate){
              Swal.fire({
                title: 'DATOS DUPLICADOS ⚠️',
                icon: 'info',
                html: `<p>ESTOS CAMPOS YA SE ENCUENTRAN REGISTRADOS DENTRO DE LA BASE DE DATOS:</p>
                      ${res.meta.fields.map(f => `<li>${f}</li>`).join("")}`,
                showConfirmButton: true,
                allowOutsideClick: false,
                allowEscapeKey: false,
                confirmButtonColor:'#ef7474',
                confirmButtonText: 'CONFIRMAR',
                padding: '0 0 20px'
              });
          }else if(!res.success){
            Swal.fire({
                title: '¡ERROR! ❌',
                icon: 'error',
                text: 'NO SE PUDIERÓN ACTUALIZAR LOS DATOS DEL EDIFICIO',
                showConfirmButton: true,
                allowOutsideClick: false,
                allowEscapeKey: false,
                confirmButtonColor:'#ef7474',
                confirmButtonText: 'CONFIRMAR',
                padding: '0 0 20px'
              });
          }
          handleClose();
          setOpenBackdrop(false);
      }
    });
  };
  return (
    <>
      <CustomBackdrop open={openBackdrop}/>
      <form className={styles.container_main_form} onSubmit={handleSubmit}>
        <img src={imgUpdate} alt="Logo" className={styles.logo_form}/>
        <Typography variant="h6" gutterBottom align='center'>ACTUALIZAR INFORMACIÓN DE EDIFICIO</Typography>
      
        <TextField
          label="CLAVE DEL EDIFICIO"
          variant="outlined"
          autoComplete="off"
          fullWidth
          className={styles.textField_form}
          name="codigo"
          value={data.codigo}
          disabled="true"
          helperText="-ESTE VALOR NO PUEDE SER MODIFICADO"
        />
        
        <TextField
          label="NOMBRE DEL EDIFICIO"
          variant="outlined"
          autoComplete="off"
          fullWidth
          className={styles.textField_form}
          name="nombre"
          value={data.nombre}
          onChange={handleChange}
          error={errors.nombre.length > 0}
          helperText={getHelperText("nombre")}
          sx={{
            '& .MuiFormHelperText-root': {
              whiteSpace: 'pre-line'
            }
          }} 
        />

        <TextField
          label="UBICACIÓN DEL EDIFICIO"
          variant="outlined"
          autoComplete="off"
          fullWidth
          className={styles.textField_form}
          name="ubicacion"
          value={data.ubicacion}
          onChange={handleChange}
          error={errors.ubicacion.length > 0}
          helperText={getHelperText("ubicacion")}
          sx={{
            '& .MuiFormHelperText-root': {
              whiteSpace: 'pre-line'
            }
          }} 
        />
        <Button
          variant="contained"
          size="large"
          startIcon={<EditDocument />}
          className={styles.button_form}
          type="submit"
          fullWidth
          color='primary'
        >
            ACTUALIZAR
        </Button>
      </form>
    </>
  );
};